<div class="language-container">
  <!-- Language selection -->
  <div class="selector-div-wrapper">
    <span>Language</span>
    <div class="selector-div">
      <select name="selector" class="selector" [(ngModel)]="tool.languageCode">
        <option *ngFor="let code of languageCodes" [selected]="tool.languageCode === code" [ngValue]="code">{{ code | uppercase }}</option>
      </select>
      <div class="vertical-line"></div>
    </div>
  </div>
  
  <!-- Apply btn -->
  <div class="bottom-wrapper mb-2">
    <button class="btn-secondary-action mx-auto" (click)="apply()">
      Aplicar cambios
    </button>
  </div>
</div>